var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentifying4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1818 15.2727V8H29.8182V15.2727H26.1818ZM38.2727 20.2727L35.7727 17.7727L40.8636 12.5455L43.4091 15.1364L38.2727 20.2727ZM40.7273 29.8182V26.1818H48V29.8182H40.7273ZM26.1818 48V40.7273H29.8182V48H26.1818ZM17.7273 20.1818L12.5455 15.1364L15.1364 12.5909L20.2727 17.7273L17.7273 20.1818ZM40.8182 43.4545L35.7727 38.2273L38.2273 35.7727L43.4091 40.7727L40.8182 43.4545ZM8 29.8182V26.1818H15.2727V29.8182H8ZM15.1364 43.4545L12.5909 40.8636L17.6818 35.7727L19 37L20.3182 38.2727L15.1364 43.4545ZM28 38.9091C24.9697 38.9091 22.3939 37.8485 20.2727 35.7273C18.1515 33.6061 17.0909 31.0303 17.0909 28C17.0909 24.9697 18.1515 22.3939 20.2727 20.2727C22.3939 18.1515 24.9697 17.0909 28 17.0909C31.0303 17.0909 33.6061 18.1515 35.7273 20.2727C37.8485 22.3939 38.9091 24.9697 38.9091 28C38.9091 31.0303 37.8485 33.6061 35.7273 35.7273C33.6061 37.8485 31.0303 38.9091 28 38.9091Z",
    fill: "#1CCEDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentifying4);
export default __webpack_public_path__ + "static/media/identifying4.daddd655cf177da1a1dcef17759a2b89.svg";
export { ForwardRef as ReactComponent };